import { MegaschoolRelease } from '@/redux/services/megaschoolReleasesApi'
import { MegaInfoCardType, MegaschoolCardType } from '@/types'
import Image from 'next/image'
import React, { useEffect, useRef, useState } from 'react'
import NewsGalleryVideo from '../news/NewsGalleryVideo'
import { createPortal } from 'react-dom'
import { useTranslation } from 'react-i18next'

interface Props {
    item: MegaschoolRelease
    i: number
    slidePrev: () => void
    slideNext: () => void
    type?: string
}

const MegaschoolCard: React.FC<Props> = ({ item, i, type }) => {
    const [videoOpen, setVideoOpen] = useState(false)
    const { t } = useTranslation()

    return (
        <>
            {createPortal(
                <NewsGalleryVideo
                    isOpen={videoOpen}
                    setIsOpen={state => setVideoOpen(state)}
                    list={item && item?.video}
                />,
                document.body
            )}
            <div
                draggable
                style={{ cursor: 'default' }}
                className='megaschool__card'
            >
                <svg
                    className='megaschool__card-hover'
                    width='356'
                    height='314'
                    viewBox='0 0 356 314'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                >
                    <g
                        style={{ mixBlendMode: 'screen' }}
                        opacity='0.6'
                    >
                        <ellipse
                            cx='178'
                            cy='157'
                            rx='178'
                            ry='157'
                            fill='url(#paint0_radial_4099_2135)'
                        />
                    </g>
                    <defs>
                        <radialGradient
                            id='paint0_radial_4099_2135'
                            cx='0'
                            cy='0'
                            r='1'
                            gradientUnits='userSpaceOnUse'
                            gradientTransform='translate(177 205) rotate(-54.8579) scale(218.9 166.771)'
                        >
                            <stop
                                stop-color='#F47F54'
                                stop-opacity='0.6'
                            />
                            <stop
                                offset='1'
                                stop-color='#3F368A'
                                stop-opacity='0'
                            />
                        </radialGradient>
                    </defs>
                </svg>
                <div className='megaschool__card-top'>
                    <p className='megaschool__card-tag categories-slider__text'>{type !== 'managers' ? `${t('release')} ${i + 1}` : 'Менеджер'}</p>
                    <h3
                        className='megaschool__card-title'
                        dangerouslySetInnerHTML={{ __html: item.title }}
                    ></h3>
                </div>
                {item.author && (
                    <div className='megaschool__text-content'>
                        <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width='26'
                            height='21'
                            viewBox='0 0 26 21'
                            fill='none'
                        >
                            <path
                                d='M11.4835 0H3.8673C3.36965 0 2.94772 0.365931 2.87735 0.858579L0.114142 20.201C0.0538988 20.6227 0.381122 21 0.807107 21H3.3406C3.74063 21 4.10217 20.7616 4.25975 20.3939L12.4026 1.39392C12.6854 0.734051 12.2014 0 11.4835 0Z'
                                fill='#BCCEF5'
                            />
                            <path
                                d='M24.4835 0H16.8673C16.3696 0 15.9477 0.365931 15.8773 0.858579L13.1141 20.201C13.0539 20.6227 13.3811 21 13.8071 21H16.3406C16.7406 21 17.1022 20.7616 17.2597 20.3939L25.4026 1.39392C25.6854 0.734051 25.2014 0 24.4835 0Z'
                                fill='#BCCEF5'
                            />
                        </svg>
                        <p className='megaschool__name'>{item.author[0]?.name}</p>
                        <p className='megaschool__text'>{item.author[0]?.post}</p>
                    </div>
                )}
                {item.video && (
                    <div
                        className='megaschool__video'
                        style={{ position: 'absolute', left: '0', right: '0' }}
                    >
                        <button
                            onClick={() => setVideoOpen(true)}
                            className='megaschool__video-btn'
                        >
                            <svg
                                width='20'
                                height='20'
                                viewBox='0 0 20 20'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                            >
                                <path
                                    d='M4.8 16.4755V3.60533C4.8 3.06572 5.3848 2.72903 5.85146 2.99996L17.2916 9.64178C17.7637 9.91588 17.7543 10.6009 17.2748 10.8619L5.83471 17.0903C5.36826 17.3442 4.8 17.0066 4.8 16.4755Z'
                                    stroke='#BCCEF5'
                                    strokeWidth='1.6'
                                    strokeLinejoin='bevel'
                                />
                            </svg>
                        </button>
                    </div>
                )}
                <Image
                    className='megaschool__card-image'
                    src={`${process.env.NEXT_PUBLIC_API_ENDPOINT_IMAGES_PROD}/${item.image}`}
                    width={type === 'managers' ? 305 : 356}
                    height={type === 'managers' ? 367 :  323}
                    alt='woman'
                />
            </div>
        </>
    )
}

export default MegaschoolCard
